import { useEffect } from 'react';

import { useParams } from 'react-router-dom';
import { TransactionChats, formatBalance, formatDate } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useCreateProblemTransactionChatMutation,
  useLazyGetProblemTransactionSenderClientsOfficiasQuery,
} from '../store/services/customers';

const ExchangeTransactionChats = (): React.JSX.Element => {
  const {
    customersProblemTransactions: {
      exchange: { chats, transaction, senderCompanyOfficials },
    },
    customersDictionaries: {
      currentEmployee,
      currenciesList,
      activePermissions,
    },
  } = useAppSelector((state) => state);

  const [createTransactionChat, { isLoading: chatCreateInProgress }] =
    useCreateProblemTransactionChatMutation();
  const [getSenderAccounts] =
    useLazyGetProblemTransactionSenderClientsOfficiasQuery();

  const { transactionId } = useParams();

  const onCreateTransactionChat = (userIds?: string[]) => {
    const title = `RFI: Exchange transaction From ${formatBalance(
      Number(transaction?.exchangeCurrencyFixedSum) || 0,
      currenciesList?.find(
        (item) => item.id === transaction?.exchangeCurrencyFromId,
      ),
    )} ${transaction?.exchangeCurrencyFrom?.name} To ${formatBalance(
      Number(transaction?.exchangeCurrencyFlexibleSum) || 0,
      currenciesList?.find(
        (item) => item.id === transaction?.exchangeCurrencyToId,
      ),
    )} ${transaction?.exchangeCurrencyTo?.name}  ${
      transaction?.transferDate ? formatDate(transaction?.transferDate) : ''
    }`;

    if (!userIds?.length) {
      createTransactionChat({
        id: transactionId as string,
        body: {
          title,
          employeeId: currentEmployee?.id as string,
          organizationId: transaction?.senderAccount?.organizationId,
        },
      });
    } else {
      Promise.all(
        userIds.map((item) =>
          createTransactionChat({
            id: transactionId as string,
            body: {
              title,
              employeeId: currentEmployee?.id as string,
              organizationId: transaction?.senderAccount?.organizationId,
              userId: item,
            },
          }),
        ),
      );
    }
  };

  useEffect(() => {
    if (
      transaction &&
      transaction.senderAccount &&
      transaction.senderAccount?.organization?.type === 'CORPORATE'
    ) {
      getSenderAccounts(transaction.senderAccount.organizationId);
    }
  }, [transaction]);

  return (
    <TransactionChats
      chats={chats}
      companyOfficials={senderCompanyOfficials}
      individualCustomer={transaction?.senderAccount}
      onCreateTransactionChat={onCreateTransactionChat}
      chatCreateInProgress={chatCreateInProgress}
      currentEmployee={currentEmployee}
      activePermissions={activePermissions}
    />
  );
};

export default ExchangeTransactionChats;
